module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publications"
  }, [(_vm.settingsObject) ? _c('div', {
    staticClass: "columns short-description"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "О финансовом ателье GrottBjörn"
    },
    on: {
      "change": function($event) {
        return _vm.updateSettings(this.settingsObject)
      }
    },
    model: {
      value: (_vm.settingsObject.aboutGrottbjornTitle),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "aboutGrottbjornTitle", $$v)
      },
      expression: "settingsObject.aboutGrottbjornTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Описание"
    },
    on: {
      "change": function($event) {
        return _vm.updateSettings(this.settingsObject)
      }
    },
    model: {
      value: (_vm.settingsObject.aboutGrottbjornText),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "aboutGrottbjornText", $$v)
      },
      expression: "settingsObject.aboutGrottbjornText"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column photo-wrapper",
    style: (_vm.photoContainerStyle)
  }, [(_vm.settingsObject.aboutGrottbjornPhoto) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAboutGrottbjornPhoto(_vm.settingsObject.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [(!_vm.settingsObject.aboutGrottbjornPhoto) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить фото\n          "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSavePublicationsData()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Публикации")]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddPublication
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить публикацию\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publications-list columns is-multiline"
  }, _vm._l((_vm.publicationsObject), function(publication) {
    return _c('router-link', {
      key: publication.id,
      staticClass: "nav-item is-tab publication-item-wrapper column is-half",
      attrs: {
        "to": {
          name: 'PublicationEditor',
          params: {
            id: publication.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "publication-item has-text-centered"
    }, [_c('span', {
      staticClass: "publication-title"
    }, [_vm._v(_vm._s(publication.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(publication.description))])])])
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82ff10d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/AllPublications.vue
// module id = 978
// module chunks = 0